import { Card, Spin } from "antd";
import React, { useState, useMemo } from "react";
import { connect } from "react-redux";
import {
  getClientid,
  getMenuList,
  getUserList,
  getUserRoleId,
} from "redux/selectors";
import Wrapper, { CardImage } from "./style";
import folder from "assets/folderLegal.png";
import { DOCUMENTFOLDER } from "common/Constants";
import DocumentTableView from "./DocumentTableView";
import { FolderFilled } from "@ant-design/icons";

const { Meta } = Card;

function DocumentFolders({
  userList,
  menuList,
  userRoleId,
  IdentityInfoColumns,
  cvInfoColumns,
  data,
  cvList,
  filteruser,
  fetchMasterData,
  clientId,
  docLoader=false,
}) {
  const [showComponent, setShowComponent] = useState(1);
  const [selectedItem, setSelectedItem] = useState({});
  const [searchTerm, setSearchTerm] = useState("");
  const [dataSource, setDataSource] = useState(userList);

  const Menulist = menuList[userRoleId] || Object.values(menuList)[0];

  const handleClick = (item) => {
    setShowComponent(2);
    setSelectedItem(item);
  };

  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value);
  };

  const filteredDataSource = dataSource?.filter((item) =>
    item.fullname.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const MemoizedCard = useMemo(() => {
    return React.memo(({ item, description = false }) => (
      <Wrapper>
        <Card
          key={item}
          hoverable
          cover={
            <CardImage className="">
              {/* <img alt="example" src={folder} /> */}
             <FolderFilled style={{textAlign:"center", fontSize: "80px", color: "#f8b400" }} />
                {/* <span
                  style={{
                    position: "absolute",
                    top: "0",
                    right: "-5px",
                    fontSize: "14px",
                    fontWeight: "bold",
                  }}
                >
                  ({0})
                </span> */}
            </CardImage>
          }
          bordered={true}
          className="cards"
          onClick={() => handleClick(item)}
        >
        <div className="label" style={{ marginTop: "15px", fontSize: "13px" ,fontWeight:500}}>
                {item.label}
              </div>
          {/* description={`Created on ${moment(item?.insertedAt).format("DD MMM YYYY")}`} */}
        </Card>
      </Wrapper>
    ));
  }, []);

  const searchStyle = { margin: "10px", maxWidth: "400px" };

  const goBack = () => {
    setShowComponent(1);
  };
  return (
    <Wrapper>
      {showComponent === 1 && (
        <>
          {/* <h5>Documents</h5>
                    <Input
                        placeholder="Search"
                        onChange={handleSearchChange}
                        suffix={<SearchOutlined />}
                        style={searchStyle}
                    /> */}
          <div className="card-container">
            {DOCUMENTFOLDER?.map((item, index) => (
              <>
                <MemoizedCard item={item} />
              </>
            ))}
          </div>
        </>
      )}
      {showComponent === 2 && (
        <>
        <Spin spinning={docLoader}>
          <DocumentTableView
            dataSource={selectedItem?.value === "cv"? cvList : data}
            IdentityInfoColumns={selectedItem?.value === "cv" ? cvInfoColumns : IdentityInfoColumns}
            goBack={goBack}
            selectedItem={selectedItem}
            filteruser={filteruser}
            fetchMasterData={fetchMasterData}
            clientId={clientId}
          />
          </Spin>
        </>
      )}
    </Wrapper>
  );
}

const mapStateToProps = (state) => ({
  userList: getUserList(state),
  menuList: getMenuList(state),
  userRoleId: getUserRoleId(state),
  clientId: getClientid(state),
});

export default connect(mapStateToProps, null)(DocumentFolders);
